/**
 * routers
 * 更多关于Router的使用，请参考以下教程
 * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
 */

import Index from "./Index";
import PageSetInfo from "./PageSetInfo";
import PageStage from "./stage/Index";
import PageStageAdd from "./stage/PageAdd";
import PageStageEdit from "./stage/PageEdit";
import PageSetProtect from "./PageSetProtect";
import PageSetProject from "./PageSetProject";

const router = {
  path: "department",
  breadcrumbName: "分属部门管理",
  childRoutes: [
    {
      path: "list",
      breadcrumbName: "部门列表",
      component: Index,
    },
    {
      path: ":uuid/stage",
      breadcrumbName: "阶段设置",
      indexRoute: { component: PageStage },
      childRoutes: [
        {
          path: "add",
          breadcrumbName: "阶段添加",
          component: PageStageAdd,
        },
        {
          path: "edit",
          breadcrumbName: "阶段编辑",
          component: PageStageEdit,
        },
      ],
    },
    {
      path: ":uuid/setInfo",
      breadcrumbName: "设置客户显示",
      component: PageSetInfo,
    },
    {
      path: ":uuid/setProtect",
      breadcrumbName: "设置客户保护限制",
      component: PageSetProtect,
    },
    {
      path: ":uuid/setProject",
      breadcrumbName: "设置客户保护限制",
      component: PageSetProject,
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/crm/department/router.js